import React from "react";

export default function Button({ children, onClick, disabled }) {
  return (
    <button
      onClick={onClick}
      className="
        relative w-full overflow-hidden
        px-4 py-3 sm:px-6 
        rounded-xl 
        font-semibold 
        text-white 
        bg-gradient-to-r from-purple-500 via-fuchsia-500 to-pink-500
        shadow-lg shadow-purple-500/30
        btn-smooth
        disabled:cursor-not-allowed disabled:opacity-60
      "
      disabled={disabled}
    >
      {/* Светящийся круг */}
      <span
        className="
          absolute inset-0 opacity-0 
          bg-white/20 
          blur-xl 
          transition-opacity duration-300
          hover:opacity-40
        "
      />

      {/* Текст */}
      <span className="relative z-10">{children}</span>
    </button>
  );
}
